import React from "react";
import { GlobeIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images, offerStack } from "../../data/offer";
const guaranteesRow = ["One-time payment", "Lifetime access", "No monthly fees", "Instant digital access"];
export function OfferSection() {
  return <section id="offer" className="bg-brand px-4 py-16 sm:px-5 sm:py-24" data-id="element-207" data-mp="6irdze0jexrn">
      <SectionHeading tone="dark" kicker="Special launch offer" title="Here's everything you'll receive today" data-id="element-208" data-mp="1pgi27x9k1ei" />

      <div className="mx-auto mt-10 max-w-2xl overflow-hidden rounded-3xl bg-cream shadow-[0_30px_60px_-20px_rgba(0,0,0,0.45)]" data-id="element-209" data-mp="3sxkn1bli58a5">
        <img src={images.mockup} alt="Everything included in Reflexology Session Blueprint™" className="w-full" loading="lazy" data-id="element-210" data-mp="3nvlihye105bm" />

        <div className="px-5 pb-8 sm:px-10" data-id="element-211" data-mp="3ex9v058ghnne">
          <ul className="divide-y divide-ink/10" data-id="element-212" data-mp="3exjj1n9xxkqg">
            {offerStack.map(row => <li key={row.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-213" data-mp="1ar8s6u6vbpaq">
                <span className="text-[16px] font-medium leading-snug text-ink" data-id="element-214" data-mp="1fjip4u6ehpmi">{row.label}</span>
                <span className="shrink-0 text-[16px] font-bold text-ink/60 line-through" data-id="element-215" data-mp="10v5p9m46zmmq">{row.value}</span>
              </li>)}
          </ul>

          <div className="mt-4 flex items-center justify-between rounded-xl bg-sand px-4 py-3" data-id="element-216" data-mp="1tiib1u2j3qez">
            <span className="text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-217" data-mp="1yhl56jgz0c86">Total reference value</span>
            <span className="font-serif text-2xl font-bold text-ink line-through decoration-coral decoration-2" data-id="element-218" data-mp="1kid57oczh02x">$244</span>
          </div>

          <div className="mt-8 text-center" data-id="element-219" data-mp="1ohub2iwbnz8m">
            <p className="text-lg text-ink/80" data-id="element-220" data-mp="92okl3n7cd5a">But today, you don't have to pay $244.</p>
            <p className="mt-3 text-sm font-extrabold uppercase tracking-wider text-brand" data-id="element-221" data-mp="95161qs655n3">Get everything for just</p>
            <p className="font-serif text-[5.5rem] font-extrabold leading-none text-coral sm:text-[7rem]" data-id="element-222" data-mp="2fqnrpi59oy3l">$27</p>
            <p className="mt-2 inline-flex items-center gap-2 rounded-full bg-brand-light px-3 py-1.5 text-sm font-semibold text-brand" data-id="element-223" data-mp="2arkl3t9n2jti">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-224" data-mp="25zazuqjgy7xk" />
              Currency is converted automatically to yours at checkout
            </p>
            <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-225" data-mp="1x0z0o04je1ti">
              {guaranteesRow.map(g => <li key={g} className="rounded-full bg-white px-3 py-1 text-xs font-bold uppercase tracking-wider text-ink ring-1 ring-ink/10" data-id="element-226" data-mp="1s134gn22zeoi">{g}</li>)}
            </ul>
          </div>

          <div className="mt-7" data-id="element-227" data-mp="1i3yfkfgup540">
            <ScarcityBar data-id="element-228" data-mp="1i4ztcrp945pf" />
          </div>

          <CTAButton label="Yes! I want Reflexology Session Blueprint™" className="mt-6" data-id="element-229" data-mp="3hg125ykruflw" />

          <Countdown className="mt-8" data-id="element-230" data-mp="3chfx9lukr7r4" />

          <p className="mt-6 text-center text-[15px] leading-relaxed text-ink/75" data-id="element-231" data-mp="3cihmcu8fduru">
            For less than the cost of a typical meal, you'll have a visual practice system you can return to whenever you study and practice reflexology.
          </p>
        </div>
      </div>
    </section>;
}